import React from 'react';

interface SpinnerInlineProps {
  modifiers?: string;
  className?: string;
}

const SpinnerInline = ({ modifiers, className }: SpinnerInlineProps) => (
  <span data-am-spinner={modifiers ? `inline ${modifiers}` : 'inline'} className={className}>
    <div className="spinner" />
  </span>
);

export default SpinnerInline;
